import styledComponents, {
  useTheme as styledUseTheme,
  ThemedStyledInterface,
} from 'styled-components'
import { Theme } from './new/theme'

export const styled: ThemedStyledInterface<Theme> = styledComponents

export const useTheme: () => Theme = styledUseTheme

export {
  createGlobalStyle,
  css,
  keyframes,
  ServerStyleSheet,
  StyleSheetManager,
} from 'styled-components'
